import React from "react";
import { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "./scss/user-management.scss";
import UserRole from "./user-role";
import { USER_MANAGEMENT } from "../../constants/route-paths";
import {
  addUser,
  getRolesList,
  getUser,
  editUser,
} from "../../actions/user-management.action";
import _ from "lodash";
import idx from "idx";
import { errorSnackBar } from "../../actions/common.action";
import { withRouter } from "../../util/with-router";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button';
import SelectInput from "../../components/inputs/select";
import CustomInput, { AmountInput } from "../../components/inputs/new-input";
import { ValidateField, ValidatorTypes } from "src/util/validators";
import WorkHourAssignmentSection from '../work-hour-settings/work-hour-assignment-section';

class AddUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {
        role: {
          name: "role",
          label: "Role",
          value: "",
          touched: false,
          error: false,
          valid: true,
          disabled: false,
          dataCy: "role-select",
          validation: [ValidatorTypes.REQUIRED],
        },
        employmentType: {
          name: "employmentType",
          label: "Employment Type",
          value: "",
          touched: false,
          error: false,
          valid: true,
          disabled: false,
          dataCy: "employment-type-select",
          validation: [ValidatorTypes.REQUIRED],
        },
        hourlyRate: {
          name: "hourlyRate",
          label: "Hourly Rate",
          value: "",
          touched: false,
          error: false,
          valid: true,
          disabled: false,
          dataCy: "hourly-rate-input",
          validation: [ValidatorTypes.REQUIRED, ValidatorTypes.HOURLY_RATE],
        },
        firstName: {
          name: "firstName",
          label: "First Name",
          value: "",
          touched: false,
          error: false,
          valid: true,
          disabled: false,
          dataCy: "first-name-input",
          validation: [ValidatorTypes.REQUIRED, ValidatorTypes.FIRST_NAME],
        },
        lastName: {
          name: "lastName",
          label: "Last Name",
          value: "",
          touched: false,
          error: false,
          valid: true,
          disabled: false,
          dataCy: "last-name-input",
          validation: [ValidatorTypes.REQUIRED, ValidatorTypes.LAST_NAME],
        },
        email: {
          name: "email",
          label: "Email",
          value: "",
          touched: false,
          error: false,
          disabled: false,
          valid: true,
          disabled: false,
          dataCy: "email-input",
          validation: [ValidatorTypes.REQUIRED, ValidatorTypes.EMAIL],
        },
        phoneNumber: {
          name: "phoneNumber",
          label: "Phone Number",
          value: "",
          touched: false,
          error: false,
          valid: true,
          disabled: false,
          dataCy: "phone-number-input",
          validation: [ValidatorTypes.OPTIONAL, ValidatorTypes.PHONE_NUMBER],
        },
        passwordType: {
          // value: 'default',  
          name: "passwordType",
          label: "Password Type",
          touched: false,
          error: false,
          valid: true,
          disabled: false,
          dataCy: "password-type-select",
          validation: [ValidatorTypes.REQUIRED, ValidatorTypes.PASSWORD_TYPE],
        },
        password: {
          name: "password",
          label: "Password",
          value: "",
          touched: false,
          error: false,
          valid: true,
          disabled: false,
          dataCy: "password-input",
          validation: [ValidatorTypes.REQUIRED, ValidatorTypes.PROJECT_TYPE_PASSWORD],
        },
        modifiedPassword: {
          name: "modifiedPassword",
          label: "New password",
          value: "",
          touched: false,
          error: false,
          disabled: false,
          valid: true,
          disabled: false,
          dataCy: "new-password-input",
          validation: [ValidatorTypes.OPTIONAL, ValidatorTypes.PROJECT_TYPE_PASSWORD],
        },
        availableDays: {
          name: "availableDays",
          days: {
            monday: {
              label: "Monday",
              value: false,
            },
            tuesday: {
              label: "Tuesday",
              value: false,
            },
            wednesday: {
              label: "Wednesday",
              value: false,
            },
            thursday: {
              label: "Thursday",
              value: false,
            },
            friday: {
              label: "Friday",
              value: false,
            },
            saturday: {
              label: "Saturday",
              value: false,
            },
            sunday: {
              label: "Sunday",
              value: false,
            },
          },
          value: "",
          touched: false,
          error: false,
          valid: true,
          disabled: false,
          dataCy: "available-days-form-elements",
          validation: [ValidatorTypes.REQUIRED, ValidatorTypes.AVAILABLE_DAYS],
        },
      },
      opneAddRoleDialog: false,
      isFormValid: false,
      roles: [],
      employmentType: [],

      // this should be in alphabetical order by value
      passwordType: [
        { value: "custom", key: "Custom" },
        { value: "default", key: "Default" },
      ],
    };
  }

  componentDidMount() {
    this.getRolesList();
    if (this.props.params.userId) {
      this.props.getUser(this.props.params.userId).then((user) => {
        this.editUser(user);
      });
    }
    const employmentType = [
      { value: "5aafb344-fa46-45cd-a1b8-7a08f34e75fb", key: "Contract" },
      { value: "d8c8969f-b824-4ed1-a4a5-db7037374656", key: "Full Time" },
    ];
    this.setState({
      employmentType: employmentType,
    });
  }

  getRolesList = () => {
    this.props.getRolesList().then((roles) => {
      const userRoles = roles.map((role) => {
        return {
          key: role.name,
          value: role.id,
        };
      });
      this.setState({ roles: userRoles });
    });
  };

  editUser = (user) => {
    const { fields } = this.state;
    fields.role.value = user.roles && user.roles.id;
    fields.email.value = user.email || "";
    fields.firstName.value = user.firstName;
    fields.lastName.value = user.lastName;
    fields.employmentType.value = user.employmentType.id;
    fields.hourlyRate.value = user.hourlyRate;
    fields.phoneNumber.value = user.phone_number;
    fields.email.disabled = !this.props.aUserPermission;
    fields.modifiedPassword.disabled = !this.props.aUserPermission;
    let available_days = idx(user, (_) => _.available_days.days) || {};
    for (let day in available_days) {
      fields.availableDays.days[day].value = available_days[day] || false;
    }
    this.setState({
      fields,
      edit: true,
      userId: user.id,
    });
  };

  inputChangeHandler = (e, fieldName = "") => {
    var name;
    var value;
    if (_.isObject(e)) {
      name = e.target.name;
      value = e.target.value || "";
    }
    if (fieldName === "phoneNumber") {
      name = fieldName;
    }

    if (fieldName === "hourlyRate") {
      if (parseFloat(value || 0) < 0) {
        return;
      }
    }

    let fields = this.state.fields;
    if (fields[name].disabled) return
    fields[name].value = value;
    fields[name].touched = true;
    const { error, valid } = this.handleValidation({
      name,
      value,
      validation: fields[name].validation
    });
    fields[name].error = error;
    fields[name].valid = valid;
    // Handle password type change
    if (name === "passwordType") {
      if (value === "default") {
        fields.password.value = "";
        fields.password.touched = false;
        fields.password.error = false;
      } else {
        fields.password.value = "";
        fields.password.touched = false;
        fields.password.error = true;
      }
    }

    let isFormValid = true;
    for (let key of Object.keys(this.state.fields)) {
      isFormValid = isFormValid && !fields[key].error;
    }
    this.setState({ fields: fields, isFormValid });
  };

  daysInputChangeHandler = (e, name = "") => {
    var value = e.target.checked || false;
    let fields = this.state.fields;
    fields.availableDays.days[name].value = value;
    fields.availableDays.touched = true;
    let isFormValid = true;
    for (let key of Object.keys(this.state.fields)) {
      isFormValid = isFormValid && !fields[key].error;
    }
    this.setState({ fields: fields, isFormValid });
  };

  handleValidation = ({ value, validation }) => {
    // Use ValidateField for all validations
    if (validation && validation.length > 0) {
      return ValidateField({ value, validation });
    }

    // Fallback validation for fields without explicit validation array
    if (
      value === undefined ||
      (!_.isBoolean(value) &&
        (typeof value === "string" ? value.trim() === "" : ""))
    ) {
      return { error: "This Field is Required" };
    }

    return { error: false };
  };

  cancelHandler = () => {
    this.props.history(`/${USER_MANAGEMENT}`);
  };

  submitForm = () => {
    const { fields, edit, userId } = this.state;

    let availableDays = { days: {} };
    for (let key in fields.availableDays.days) {
      availableDays.days[key] = fields.availableDays.days[key].value;
    }

    let isFormValid = true;
    for (let key in fields) {
      // Skip password validation for edit mode and password type when using default password
      if (
        (key === "password" && (fields.passwordType.value === "default" || edit)) ||
        (edit && key === "passwordType")
      ) {
        continue;
      }

      const { error, valid } = this.handleValidation({
        value: key === "availableDays" ? fields[key] : fields[key].value,
        validation: fields[key].validation
      });
      fields[key].touched = true;
      fields[key].error = error;
      fields[key].valid = valid;
      isFormValid = isFormValid && valid;
      if (key === "availableDays" && !valid) {
        this.props.errorSnackBar(fields[key].error);
      }
    }
    if (!isFormValid) {
      this.setState({ fields: fields, isFormValid });
    } else {
      const data = {
        firstName: fields.firstName.value,
        lastName: fields.lastName.value || '',
        role: fields.role.value,
        employmentType: fields.employmentType.value,
        hourlyRate: fields.hourlyRate.value,
        phoneNumber: fields.phoneNumber.value,
        email: fields.email.value,
        availableDays,
      };
      if (!edit) {
        data.password =
          fields.passwordType.value === "custom" ? fields.password.value : null;
        data.status = "ACTIVE";
      }
      if (fields.modifiedPassword.value) {
        data.modifiedPassword = fields.modifiedPassword.value;
      }
      if (edit) {
        this.props.editUser(data, userId).then((res) => {
          this.props.history("/user-management");
        }).catch(e => console.error(e));
      } else {
        this.props.addUser(data).then((res) => {
          this.props.history("/user-management");
        }).catch(e => console.error(e));
      }
    }
  };

  AddRoleDialogHandler = () => {
    if (this.state.opneAddRoleDialog) this.getRolesList();
    const dialogState = this.state.opneAddRoleDialog;
    this.setState({ opneAddRoleDialog: !dialogState });
  };

  render() {
    const {
      fields,
      roles,
      employmentType,
      passwordType,
      opneAddRoleDialog,
      edit,
    } = this.state;
    const { writePermission } = this.props;
    let availableDaysFormElements = Object.keys(fields.availableDays.days).map((key) => {
      return (
        <Form key={key} className="usercheckbox me-3">
          <div className="table-checkbox">
            <Form.Check
              type={'checkbox'}
              id={`${key}-check`}
              label={fields.availableDays.days[key].label}
              value={fields.availableDays.days[key].value}
              checked={fields.availableDays.days[key].value}
              onChange={(e) => this.daysInputChangeHandler(e, key)}
              data-cy={`available-days-form-element-checkbox-${key}`}
            />
          </div>
        </Form>
      );
    });

    return (
      <>
        {
          opneAddRoleDialog && <UserRole
            open={opneAddRoleDialog}
            handleClose={this.AddRoleDialogHandler}
            addUser
          />
        }
        <div className="purchase-order-block" data-cy={this.props.params.userId ? "edit-user-page" : "add-user-page"}>
          <div className="row">
            <div className="w-auto">
              <h2 className="content-heading text-uppercase">
                {this.props.params.userId ? "Edit User" : "Add a User"}
              </h2>
              <div className="col-12 breadcrumb-block p-0">
                <Breadcrumb>
                  <Breadcrumb.Item onClick={this.cancelHandler}>USERS</Breadcrumb.Item>
                  <Breadcrumb.Item active>
                    {this.props.params.userId ? "Edit User" : "Add a User"}
                  </Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </div>
            <div className="w-auto ms-auto">
              {writePermission && <button onClick={this.AddRoleDialogHandler} className="secondarybtn secondarybtn-outline btn-ch ms-auto btn btn-primary">
                Create New User Role
              </button>}
            </div>
          </div>

          <div className="row" data-cy="basic-details-tab">
            <div className="col-12">
              <h2 className="content-heading content-heading-lg text-uppercase my-auto me-auto">Basic Details</h2>
            </div>
            <div className="col-lg-4 col-md-6 mt-3">
              <SelectInput
                {...fields.role}
                onChange={(e) => this.inputChangeHandler(e)}
                items={roles}
              />
            </div>
            <div className="col-lg-4 col-md-6 mt-3">
              <SelectInput
                {...fields.employmentType}
                onChange={(e) => this.inputChangeHandler(e)}
                items={employmentType}
              />
            </div>
            <div className="col-lg-4 col-md-6 mt-3">
              <AmountInput
                {...fields.hourlyRate}
                onChange={(e) => this.inputChangeHandler(e, "hourlyRate")}
              />
            </div>
            <div className="col-lg-4 col-md-6 mt-3">
              <CustomInput
                {...fields.firstName}
                onChange={(e) => this.inputChangeHandler(e, "firstName")}
              />
            </div>
            <div className="col-lg-4 col-md-6 mt-3">
              <CustomInput
                {...fields.lastName}
                onChange={(e) => this.inputChangeHandler(e, "lastName")}
              />
            </div>
            <div className="col-lg-4 col-md-6 mt-3">
              <CustomInput
                {...fields.email}
                onChange={(e) => this.inputChangeHandler(e, "email")}
              />
            </div>
            <div className="col-lg-4 col-md-6 mt-3">
              <CustomInput
                {...fields.phoneNumber}
                onChange={(e) => this.inputChangeHandler(e, "phoneNumber")}
              />
            </div>
            {edit ? (
              writePermission && (
                <div className="col-lg-4 col-md-6 mt-3">
                  <CustomInput
                    {...fields.modifiedPassword}
                    onChange={(e) => this.inputChangeHandler(e)}
                  />
                  {fields.modifiedPassword.value && !fields.modifiedPassword.error && (
                    <small className="text-danger" data-cy="password-modified-warning">
                      Password will be modified for this user!
                    </small>
                  )}
                </div>
              )
            ) : (
              <div className="col-lg-4 col-md-6 mt-3">
                <SelectInput
                  {...fields.passwordType}
                  onChange={(e) => this.inputChangeHandler(e)}
                  items={passwordType}
                />
              </div>
            )}
            {fields.passwordType.value === "custom" && (
              <div className="col-lg-4 col-md-6 mt-3">
                <CustomInput
                  {...fields.password}
                  onChange={(e) => this.inputChangeHandler(e)}
                />
              </div>
            )}
            <div className="col-12 my-2">
              <hr></hr>
            </div>
            <div className="col-12">
              <h2 className="content-heading content-heading-sm text-uppercase my-auto me-auto" data-cy="available-days-heading">Available Days</h2>
            </div>
            <div className="col-12 mt-3 text-left mb-3" data-cy="available-days-form-elements">
              {availableDaysFormElements}
            </div>
          </div>

          {edit && (
            <WorkHourAssignmentSection
              userId={this.state.userId}
              writePermission={writePermission}
            />
          )}

          <div className="col-12 d-flex justify-content-end gap-3 mt-3">
            {writePermission && <Button onClick={this.submitForm} className="secondarybtn" data-cy="done-button">DONE</Button>}
            <Button onClick={this.cancelHandler} className="secondarybtn cancelbtn" data-cy="cancel-button">CANCEL</Button>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  addUser: bindActionCreators(addUser, dispatch),
  getRolesList: bindActionCreators(getRolesList, dispatch),
  getUser: bindActionCreators(getUser, dispatch),
  editUser: bindActionCreators(editUser, dispatch),
  errorSnackBar: bindActionCreators(errorSnackBar, dispatch),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddUser)
);
